
const digest = '33f2ebbb01415992f65b768acd48236382da78b51ac01376029d84051a8f5a5d';
const classes = {"wrapper":"_wrapper_ei4xz_1","title":"_title_ei4xz_9","button":"_button_ei4xz_13","circle1":"_circle1_ei4xz_21","circle2":"_circle2_ei4xz_30"};
const css = `._wrapper_ei4xz_1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  text-align: center;
  padding: 30px;
}
._wrapper_ei4xz_1 ._title_ei4xz_9 {
  font-size: 22px;
  font-weight: 600;
}
._wrapper_ei4xz_1 ._button_ei4xz_13 {
  font-weight: 600;
  background: linear-gradient(135deg, #1e6ce3 0%, #0054bc 100%);
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  width: 100%;
}
._wrapper_ei4xz_1 ._circle1_ei4xz_21 {
  background-color: #f0fdf4;
  border-radius: 100%;
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_ei4xz_1 ._circle1_ei4xz_21 ._circle2_ei4xz_30 {
  background-color: #dcfce7;
  border-radius: 100%;
  height: 65px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_ei4xz_1 ._circle1_ei4xz_21 ._circle2_ei4xz_30 img {
  height: 35px;
  width: 35px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  